<template>
	<div class="page container">
		<div class="page__info">
			<div class="page__info--title">
				Create new course
			</div>
		</div>

		<div>
			<category-edit
				:cancelRoute="getCancelRoute"
				:isCreate="true"
			/>
		</div>
	</div>
</template>

<script>
	import CategoryEdit  from '@/components/knowledgebase/edit/CategoryEdit';

	export default {
		layout: 'v2default',
		metaInfo: {
			title: 'Create new category'
		},
		components: {
			CategoryEdit
		},
		data: () => ({}),
		computed: {
			getCancelRoute () {
				return '/admin/knowledgebase/categories';
			}
		},
		created () {},
		methods: {}
	};

</script>
